export default "__VITE_ASSET__lmjOaGr4__"